import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray, lightGray, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 1000,
		padding: 24,
	},
	modal: {
		backgroundColor: white,
		borderRadius: 12,
		maxWidth: 640,
		width: '100%',
		maxHeight: '80vh',
		overflow: 'hidden',
		display: 'flex',
		flexDirection: 'column',
		boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '24px 24px 20px',
		borderBottom: `1px solid ${lightGray}`,
	},
	title: {
		fontSize: 20,
		fontWeight: 600,
		color: '#1f2937',
		margin: 0,
	},
	closeButton: {
		padding: 8,
		backgroundColor: 'transparent',
		border: 'none',
		cursor: 'pointer',
		color: charmGray,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 6,
		minHeight: 44,
		minWidth: 44,
		':hover': {
			backgroundColor: lightGray,
			color: '#1f2937',
		},
		':focus': {
			outline: `3px solid ${brandPrimary}40`,
			outlineOffset: 2,
		},
	},
	content: {
		padding: 24,
		overflowY: 'auto',
	},
	category: {
		marginBottom: 32,
		':last-child': {
			marginBottom: 0,
		},
	},
	categoryTitle: {
		fontSize: 14,
		fontWeight: 600,
		color: charmGray,
		textTransform: 'uppercase',
		letterSpacing: '0.05em',
		marginBottom: 16,
		margin: '0 0 16px 0',
	},
	shortcutsList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
	},
	shortcutItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '8px 0',
	},
	keysContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		minWidth: 140,
	},
	key: {
		display: 'inline-block',
		padding: '4px 10px',
		backgroundColor: lightGray,
		border: '1px solid #d1d5db',
		borderRadius: 6,
		fontSize: 13,
		fontWeight: 600,
		fontFamily: 'monospace',
		color: '#374151',
		boxShadow: '0 2px 0 rgba(0, 0, 0, 0.05)',
	},
	keySeparator: {
		margin: '0 4px',
		color: charmGray,
		fontSize: 12,
	},
	description: {
		fontSize: 14,
		color: '#4b5563',
		flex: 1,
	},
});
